import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Diwali sale page header (shared): "🪔 BEAT22 DIWALI SALE", the sale countdown on one line, sale dates, tagline
 * and the shimmer bar.
 * Usage: <ipm-diwali-sale-header [startAt]="..." [endAt]="..."></ipm-diwali-sale-header>
 */
@Component({
  selector: 'ipm-diwali-sale-header',
  templateUrl: './diwali-sale-header.component.html',
  styleUrls: ['./diwali-sale-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiwaliSaleHeaderComponent {
  @Input() startAt: string | null = null;
  @Input() endAt: string | null = null;
  @Input() tagline: string = 'Beats at up to 50% off — limited time only';
  @Input() isTagShown: boolean = false;
}
